import { DETERMINAR_PAGINA_ATUAL_CTE_OS } from '../types'

export default function determinarPaginaAtualCteOs (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_CTE_OS,
    payload: paginaAtual
  }
}